import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'withoutsnake',
})
export class WithoutSnakePipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) {
      return '';
    }
    return value.replace(/_/g, ' ');
  }
}
